import Breadcrumb from '../Component/Breadcrumb'
const AssesmentPromo = () => {
    return (
        <>
            <Breadcrumb breadtitle="Assessments & Promotion" breadmid="Academic" breadend="Assessments & Promotion" />
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className='maintitle'>Assessments & Promotion
</h2>
                            <ul className='list-view' >
            <li>There will be Four Formative and Two Summative Assessments.</li>
            <li>Students should score 40% marks for promotion.</li>
            <li>Medical Certificates will be accepted after a proper enquiry or information. When a student is granted
              Medical Leave during Assessments she will be promoted to the next class. if her pecontainer-fluidormance
              throughout the year is found satisfactory.</li>
            <li>The marks obrained in FA1, FA2, FA3, FA4 and SA1 and SA2 will be converted into grades as per C.B.S.E.
              norms.</li>
            <li>Progress Reports will be given to the parents on the day notified and these will be returned duly signed
              within three days. Parents or gaurdians are requested to examine the Progress Report carefully and see
              that their wards make effort to study those subjects in which he/she is weak.</li>
            <li>If a student is not making any progress, parents are welcome to contact the Principal, the class teacher
              or the subject teacher concerned on the second Saturday of every month, to discuss the remedial measures
              to be taken. </li>
            <li>Once the Results are declared no change will be possible and no further discussion on the matter will be
              entertained.</li>
            <li>No Assessments will be conducted either before or after the given schedule.</li>
          </ul>
                        </div>
                    </div>
                </div> 
            </div>
        </>
    )
}
export default AssesmentPromo